/**
 * 薛煜如
 * 工单相关工具类
 */
 import { message } from 'ant-design-vue'
 import { batchList } from '@api'
/**
 * 获取批次列表
 * @param {*} workOrderId 
 * @returns 
 */
async function getBatchList(workOrderId){
  let list = []
  if(!workOrderId) {
    return list
  }
  let {data} = await batchList(workOrderId)
  if(!data || data.length < 1){
    let errMsg = '该任务未生成批次，请检查！'
    message.warning(errMsg)
    throw new Error(errMsg)
  }
  list = data
  return list
}

export default {
  getBatchList
}